import { Injectable } from '@angular/core';
import { IPage, Chapter, PagePath } from '../../models/page-model';
import { QuestionnaireService } from '../questionnaire/questionnaire.service';
import { Router } from '@angular/router';
import { ExperimentsService } from '../experiments/experiments.service';
import { ProductConfigurationIds } from '../../models/cart-model';

@Injectable()
export class QuestionnaireRoutingMobileNativeService {
  public page: IPage;

  constructor(
    private questionnaireService: QuestionnaireService,
    private router: Router,
    private experimentService: ExperimentsService
  ) { }


  private overrideNextPage(): void {
    if (this.experimentService.getGloDesignTest()) {
      if (this.page instanceof GSuitePackagePage) {
        const gsuitPage: IPage = {
          nextPage: () => {
            return Chapter.PostOrder + '/' + PagePath.OrderLoading;
          },
          previousPage(): string {
            return null;
          }
        };
        this.page = gsuitPage;
      }
    }
  }

  private overridePrevPage(): void {    
  }

  getNextPage(currentPage: string): string {
    this.page = this.getPage(currentPage);
    this.questionnaireService.broswerHistory = [];

    this.overrideNextPage();

    return this.page.nextPage();
  }

  getPreviousPage(currentPage: string): string {
    this.page = this.getPage(currentPage);

    this.overridePrevPage();

    return this.page.previousPage();
  }

  private getPage(page: string): IPage {
    switch (page) {
      case PagePath.Overview:
        return new OverviewPage(this.questionnaireService);
      case PagePath.BusinessState:
        return new BusinessStatePage(this.questionnaireService);
      case PagePath.NameAvailable:
        return new NameAvailablePage(this.questionnaireService);
      case PagePath.BusinessStartTime:
        return new BusinessStartTimePage(this.questionnaireService, this.experimentService);
      case PagePath.BusinessStartTimeDetail:
        return new BusinessStartTimeDetailPage(this.questionnaireService);
      case PagePath.FirstLlc:
        return new FirstLlcPage(this.questionnaireService);
      case PagePath.BusinessPurpose:
        return new BusinessPurposePage(this.questionnaireService);
      case PagePath.HireEmployees:
        return new HireEmployeesPage(this.questionnaireService);
      case PagePath.EssentialExtras:
      case Chapter.Essentials:
        return new EssentialExtrasPage(this.questionnaireService);
      case PagePath.RegisteredAgent:
        return new RegisteredAgentPage(this.questionnaireService);
      case PagePath.CriticalDocuments:
        return new CriticalDocumentsPage(this.questionnaireService);      
      case PagePath.StateTax:
        return new StateTaxPage(this.questionnaireService);
      case PagePath.Extras:
      case Chapter.Services:
        return new ExtrasPage(this.questionnaireService);
      case PagePath.Compliance:
        return new CompliancePage(this.questionnaireService, this.experimentService);
      case PagePath.Clientbooks:
        return new ClientbooksPage(this.questionnaireService);
      case PagePath.Legal:
        return new LegalPage(this.questionnaireService);
      case PagePath.PackageSelection:
        return new PackageSelectionPage(this.questionnaireService, this.experimentService);
      case PagePath.BofA:
        return new BofAPage(this.questionnaireService);
      case PagePath.ReviewYourOrder:
        return new ReviewYourOrderPage(this.questionnaireService);
      case PagePath.Checkout:
        return new CheckoutPage(this.questionnaireService);
      case PagePath.ExpressOffersPage:
        return new ExpressOffersPage(this.questionnaireService);
      case PagePath.GSuitePackage:
        return new GSuitePackagePage(this.questionnaireService);
      case PagePath.OrderLoading:
        return  new OrderLoadingPage();
      case PagePath.OrderConfirmation:
        return new OrderConfirmationPage(this.questionnaireService);
      case PagePath.RemainingQuestions:
        return new RemainingQuestionsPage(this.questionnaireService);
      case PagePath.PartnerOffers:
        return new PartnerOffersPage(this.router, this.questionnaireService);
      case PagePath.OrderConfirmationRibbon:
        return new OrderConfirmationRibbonPage(this.questionnaireService);
      case PagePath.OrderConfirmationCongrats:
        return new OrderConfirmationCongratsPage(this.questionnaireService);
      default:
        return new OverviewPage(this.questionnaireService);
    }
  }
}

class OverviewPage implements IPage {

  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Name + '/' + PagePath.BusinessState;
  }

  previousPage(): string {
    // No previous page
    return Chapter.Name + '/' + PagePath.BusinessState;
  }

  chapterNumber(): number {
    return 1;
  }
}

class BusinessStatePage implements IPage {
  private path: string;

  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Name + '/' + PagePath.NameAvailable;

  }

  previousPage(): string {
    return Chapter.Name + '/' + PagePath.ChangeName;
  }
}

class NameAvailablePage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Business + '/' + PagePath.BusinessStartTime;
  }

  previousPage(): string {
    return Chapter.Name + '/' + PagePath.BusinessState;
  }

  chapterNumber(): number {
    return 1;
  }
}
class BusinessStartTimePage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService,
    private experimentService: ExperimentsService) {
  }

  nextPage(): string {
    return Chapter.Business + '/' + PagePath.BusinessStartTimeDetail;
  }

  previousPage(): string {
    return Chapter.Name + '/' + PagePath.NameAvailable;
  }
}

class BusinessStartTimeDetailPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Business + '/' + PagePath.FirstLlc;
  }

  previousPage(): string {
    return Chapter.Business + '/' + PagePath.BusinessStartTime;
  }
}

class FirstLlcPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Business + '/' + PagePath.BusinessPurpose;
  }

  previousPage(): string {
    return Chapter.Business + '/' + PagePath.BusinessStartTimeDetail;
  }

}

class BusinessPurposePage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Business + '/' + PagePath.HireEmployees;
  }

  previousPage(): string {
    return Chapter.Business + '/' + PagePath.FirstLlc;
  }
}
class HireEmployeesPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Essentials;
  }

  previousPage(): string {
    return Chapter.Business + '/' + PagePath.BusinessPurpose;
  }

}
class EssentialExtrasPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Essentials + '/' + PagePath.RegisteredAgent;
  }

  previousPage(): string {
    return Chapter.Business + '/' + PagePath.HireEmployees;
  }


}

class RegisteredAgentPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Essentials + '/' + PagePath.CriticalDocuments;
  }

  previousPage(): string {
    return Chapter.Essentials;
  }

}

class CriticalDocumentsPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Services;
  }

  previousPage(): string {
    return Chapter.Essentials + '/' + PagePath.RegisteredAgent;
  }

}

class StateTaxPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Services;
  }

  previousPage(): string {
    return Chapter.Essentials + '/' + PagePath.CriticalDocuments;
  }
}

class ExtrasPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Services + '/' + PagePath.Legal;
  }

  previousPage(): string {
    return Chapter.Essentials + '/' + PagePath.CriticalDocuments;
  }
}
class LegalPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Services + '/' + PagePath.Compliance;
  }

  previousPage(): string {
    return Chapter.Services;
  }
}

class CompliancePage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService,
    private experimentsService: ExperimentsService) {
  }

  nextPage(): string {
    return Chapter.Package + '/' + PagePath.PackageSelection;
  }

  previousPage(): string {
    return Chapter.Services + '/' + PagePath.Legal;
  }
}

class ClientbooksPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Package + '/' + PagePath.PackageSelection;
  }

  previousPage(): string {
    return Chapter.Services + '/' + PagePath.Compliance;
  }
}

class PackageSelectionPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService,
    private experimentsService: ExperimentsService) {
  }

  nextPage(): string {
    return Chapter.Package + '/' + PagePath.BofA;
  }

  previousPage(): string {
    return Chapter.Services + '/' + PagePath.Compliance;
  }
}

class BofAPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.Checkout + '/' + PagePath.ReviewYourOrder;
  }

  previousPage(): string {
    return Chapter.Package + '/' + PagePath.PackageSelection;
  }
}

class ReviewYourOrderPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
      return Chapter.Checkout + '/' + PagePath.Checkout;
  }

  previousPage(): string {
    return Chapter.Package + '/' + PagePath.BofA;
  }
}

class CheckoutPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.PostOrder + '/' + PagePath.ExpressOffersPage;
  }

  previousPage(): string {
    return Chapter.Checkout + '/' + PagePath.ReviewYourOrder;
  }
}

class ExpressOffersPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.PostOrder + '/' + PagePath.GSuitePackage;
  }

  previousPage(): string {
    return null;
  }
}

class GSuitePackagePage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }
  nextPage(): string {
    return Chapter.PostOrder + '/' + PagePath.OrderConfirmation;
  }

  previousPage(): string {
    // previous page is payment page
    return null;
  }
}
class OrderLoadingPage implements IPage {
  constructor() {
  }
  nextPage(): string {
    return Chapter.PostOrder + '/' + PagePath.OrderConfirmation;
  }

  previousPage(): string {
    // previous page is payment page
    return null;
  }
}

class OrderConfirmationPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.PostOrder + '/' + PagePath.RemainingQuestions;
  }

  previousPage(): string {
    // previous page is payment page
    return null;
  }

}

class RemainingQuestionsPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.PostOrder + '/' + PagePath.PartnerOffers;
  }

  previousPage(): string {
    return Chapter.PostOrder + '/' + PagePath.OrderConfirmation;
  }
}

class PartnerOffersPage implements IPage {
  constructor(
    private router: Router,
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.PostOrder + '/' + PagePath.OrderConfirmationRibbon;
  }

  previousPage(): string {
    return Chapter.PostOrder + '/' + PagePath.RemainingQuestions;
  }
}

class OrderConfirmationRibbonPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    return Chapter.PostOrder + '/' + PagePath.OrderConfirmationCongrats;
  }

  previousPage(): string {
    return Chapter.PostOrder + '/' + PagePath.PartnerOffers;
  }
}

class OrderConfirmationCongratsPage implements IPage {
  constructor(
    private questionnaireService: QuestionnaireService) {
  }

  nextPage(): string {
    // last page of flow
    return null;
  }

  previousPage(): string {
    return Chapter.PostOrder + '/' + PagePath.OrderConfirmationRibbon;
  }
}
